var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-filter-wrap"},[(_vm.activeTab === 1)?[_c('Ukrposhta')]:_vm._e(),(_vm.activeTab === 2)?[_c('NovaPoshta')]:_vm._e(),(_vm.activeTab === 3)?[_c('Belposhta')]:_vm._e(),(_vm.activeTab === 4)?[_c('CDEK')]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }